import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../../_services/_nav.service';
import { Campania } from '../../../_models/campania';
import { AutenticacionService } from '../../../_services/autenticacion.service';
import { CampaniaDctoMontos } from '../../../_models/campania-dcto-montos';
import { CampaniaDctoMontoservice } from '../../../_services/campania-dcto-monto.service';
import { Table } from 'primeng/table';

@Component( {
  selector: 'app-campanias-dcto-montos',
  templateUrl: 'campanias-dcto-montos.component.html'
} )

export class CampaniasDctoMontosComponent implements OnInit {

  @Input() campania: Campania;
  campaniaDctoMontos: CampaniaDctoMontos;
  // Lista de campañas descuentos Montos
  lisCampaniasDctoMontos: CampaniaDctoMontos [] = [];
  carInformacionInicial = true;
  formulario: FormGroup;
  submitted = false;
  guardando = false;
  columnas: any[];
  guardandoCampaniaDctoMontos = false;
  submittedCampaniaDctoMontos = false;
  tabSeleccionado = 'CAMM';
  carTabla = true;
  @ViewChild('dt') tabla: Table;

  constructor( private autServicio: AutenticacionService,
               private camDctoMontoservicio: CampaniaDctoMontoservice,
               private conServicio: ConfirmationService,
               private nav: NavService,
               private confirmationService: ConfirmationService,
               private fb: FormBuilder ) {

  }

  ngOnInit(): void {
    // Definiendo columnas datatable
    this.columnas = [
      { field: 'montoMinimo', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_SMLVMINIMO' ), sort: false },
      { field: 'montomaximo', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_SMLVMAXIMO' ), sort: false },
      { field: 'descuentoTasa', header: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.LBL_DESCUENTOTASA' ), sort: false },
      { field: 'acciones', header: this.nav.buscarMensaje( 'LBL_ACCIONES' ), sort: false },
    ];
    // Inicializando formulario
    this.carServicio();
    this.cargarTabla();
  }

  carServicio() {
    this.formulario = this.fb.group( {
      idCampaniaDctoMonto: [this.campaniaDctoMontos ? this.campaniaDctoMontos.idCampaniaDctoMonto : null],
      idCampania: [this.campania ? this.campania.idCampania : null, [Validators.required]],
      montoMinimo: [this.campaniaDctoMontos ? this.campaniaDctoMontos.montoMinimo : null, [Validators.required]],
      montoMaximo: [this.campaniaDctoMontos ? this.campaniaDctoMontos.montoMaximo : null, [Validators.required]],
      descuentoTasa: [this.campaniaDctoMontos ? this.campaniaDctoMontos.descuentoTasa : null, [Validators.required]],
      indicadorSuma: [this.campaniaDctoMontos ? this.campaniaDctoMontos.indicadorSuma : false, [Validators.required]],
      indicadorHabilitado: [this.campaniaDctoMontos ? this.campaniaDctoMontos.indicadorHabilitado : true, [Validators.required]],
    } );

    this.carInformacionInicial = false;
  }

  onSubmit() {
    this.submitted = true;
    if ( this.formulario.valid ) {
      this.guardando = true;
      this.carTabla = true;
      //guardar campania descuentos Montos
      this.crearCampaniaDctoMonto();
    }
  }


  crearCampaniaDctoMonto() {
    const formulario = this.formulario.getRawValue();
    /** se obtienen los valores del rango */
    const min = Number( formulario.montoMinimo );
    const max = Number( formulario.montoMaximo );
    if ( Number( formulario.montoMinimo ) >= Number( formulario.montoMaximo ) ) {
      this.nav.setMesage( 0, {
        severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.MSG_RANGOMONTOS' )
      } );
      this.guardando = false;
    } else {
      if ( formulario.idCampaniaDctoMonto ) {
        /** actualizacion del registro */
        const mismoRango = this.lisCampaniasDctoMontos.find( x => x.idCampaniaDctoMonto === formulario.idCampaniaDctoMonto/* Number( formulario.idCampaniaDctoMonto ) */ );
        /** se valida si va a actualizar solo el descuento tasa */
        if ( mismoRango && (mismoRango.montoMinimo === Number( formulario.montoMinimo ) &&
          mismoRango.montoMaximo === Number( formulario.montoMaximo )) ) {
          this.actualizarCampaniaDctoMontos( formulario );
        } else {
          /** se valida el rango */
          if ( this.validarRango( min, max, formulario.idCampaniaDctoMonto ) ) {
            /** Se actualiza normal */
            this.actualizarCampaniaDctoMontos( formulario );
          } else {
            this.finalizarGuardado( false );
            this.nav.setMesage( 0, {
              severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
              detail: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.MSG_ERRORRANGO' )
            } );
          }
        }
      } else {
        /** creacion del registro */
        if ( this.validarRango( min, max ) ) {
          /** si el rango es valido se valida si ya existe el mismo rango en un registro inhabilitado y si es asi se habilita el registro */
          const existeInhabilitado = this.lisCampaniasDctoMontos.find( y => min === y.montoMinimo &&
            max === y.montoMaximo && !y.indicadorHabilitado && y.idCampaniaDctoMonto !== formulario.idCampaniaDctoMonto );
          if ( existeInhabilitado ) {
            formulario.idCampaniaDctoMonto = existeInhabilitado.idCampaniaDctoMonto;
            this.actualizarCampaniaDctoMontos( formulario, true );
          } else {
            this.guardarRegistro( formulario );
          }
        } else {
          this.finalizarGuardado( false );
          this.nav.setMesage( 0, {
            severity: 'info', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
            detail: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.MSG_ERRORRANGO' )
          } );
        }
      }
    }
  }

  actualizarCampaniaDctoMontos( formulario: any, guardar?: boolean ) {
    this.camDctoMontoservicio.actualizar( formulario ).subscribe( regAct => {
      this.cargarTabla();
      this.guardando = false;
      this.finalizarGuardado( true );
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( (guardar === true) ? 'CAMPANIADCTOMONTO.MSG_REGCREA' : 'CAMPANIADCTOMONTO.MSG_REGACTU' )
      } );
    } );
  }

  finalizarGuardado( recargar: boolean ) {
    if ( recargar ) {
      this.campaniaDctoMontos = null;
      this.formulario.reset();
      this.carServicio();
    }
    this.guardando = false;
    this.carTabla = false;
    this.submitted = false;
  }

  // Carga el registro en el formulario para ser editada
  editarCampaniaDctoMontos( campaniaDctoMontos: CampaniaDctoMontos ) {
    this.campaniaDctoMontos = campaniaDctoMontos;
    this.carServicio();
  }

  cargarTabla() {
    this.carTabla = true;
    this.lisCampaniasDctoMontos = [];
    this.camDctoMontoservicio.listadoCampaniasDctoMontosIdCampania( this.campania.idCampania ).subscribe( res => {
      this.lisCampaniasDctoMontos = res;
      this.carTabla = false;
      this.guardando = false;
    } );
  }

  obtenerCampanias() {
    return this.lisCampaniasDctoMontos.filter( x => x.indicadorHabilitado );
  }

  guardarRegistro( formulario: any ) {
    this.camDctoMontoservicio.crear( formulario ).subscribe( reg => {
      this.cargarTabla();
      this.finalizarGuardado( true );
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.MSG_REGCREA' )
      } );
    } );
  }

//inhabilitar el registro
  eliminarCampaniaDctoMontos( item: CampaniaDctoMontos ) {
    item.indicadorHabilitado = false;
    this.camDctoMontoservicio.actualizar( item ).subscribe( regAct => {
      this.lisCampaniasDctoMontos.map( ( s: CampaniaDctoMontos ) => {
        if ( item.idCampaniaDctoMonto === s.idCampaniaDctoMonto ) {
          s.indicadorHabilitado = false;
        }
      } );
      this.nav.setMesage( 0, {
        severity: 'success', summary: this.nav.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.nav.buscarMensaje( 'CAMPANIADCTOMONTO.MSG_REGELIM' )
      } );
    } );
  }

  validarRango( min: number, max: number, idActualizando?: string ) {
    let valido = true;
    this.lisCampaniasDctoMontos = this.lisCampaniasDctoMontos.filter( x => x.indicadorHabilitado );
    if ( this.lisCampaniasDctoMontos.length > 0 ) {
      this.lisCampaniasDctoMontos.map( ( s: CampaniaDctoMontos ) => {
        if ( idActualizando && (idActualizando !== '' &&idActualizando !== null && idActualizando !== undefined) ) {
          if ( ((min >= s.montoMinimo && min <= s.montoMaximo) || (max >= s.montoMinimo && max <= s.montoMaximo)) && s.indicadorHabilitado
            && s.idCampaniaDctoMonto !== idActualizando ) {
            valido = false;
          } else if ( min <= s.montoMinimo && s.montoMaximo <= max ) {
            valido = false;
          }
        } else {
          if ( ((min >= s.montoMinimo && min <= s.montoMaximo) || (max >= s.montoMinimo && max <= s.montoMaximo))
            && s.indicadorHabilitado ) {
            valido = false;
          } else if ( min < s.montoMinimo && s.montoMaximo < max ) {
            valido = false;
          }
        }
      } );
    }
    return valido;
  }

  get f() {
    return this.formulario.controls;
  }

}
